/**
 * @fileoverview Derived list and pagination view-model for the company catalog.
 * @module hooks/companyCatalog/buildCompanyCatalogViewModel
 */
import { paginateCompanies } from "../../logic/companyCatalog/index.js";
import {
  getLoadedPagesCount,
  getTotalPages,
} from "./companyCatalogPaginationUtils.js";

/**
 * Builds the paginated slice and total page count shown by the catalog table.
 *
 * @param {Object} params Current catalog pagination inputs
 * @param {Array<Object>} params.companiesData Full in-memory catalog rows
 * @param {number} params.currentPage Active 1-based page index
 * @param {number} params.resultsLimit Selected page size from the toolbar
 * @param {string|null} params.lastKey DynamoDB cursor for additional pages
 * @param {boolean} params.limitReached Whether remote pagination has no more rows
 * @returns {{
 *   paginatedCompaniesList: Array<Object>,
 *   totalPages: number
 * }} View-model values consumed by the CompanyCatalog page component
 */
export const buildCompanyCatalogViewModel = ({
  companiesData,
  currentPage,
  resultsLimit,
  lastKey,
  limitReached,
}) => {
  const paginatedCompaniesList = paginateCompanies(
    companiesData,
    currentPage,
    resultsLimit,
  );
  const loadedPages = getLoadedPagesCount(companiesData.length, resultsLimit);
  const totalPages = getTotalPages(loadedPages, lastKey, limitReached);

  return {
    paginatedCompaniesList,
    totalPages,
  };
};
